import {
    makeExecutorUrl,
    trans,
} from '@frontend/helpers'
import type {ChatExecutorData} from '@frontend/modules/private/chats/ChatsModuleTypes'
import {Link} from 'react-router-dom'
import {LabeledValue} from 'swayok-react-mdb-ui-kit/components/Typography/LabeledValue'

interface Props {
    executor: ChatExecutorData
}

// Информация об исполнителе, который предлагает свои услуги по объявлению
// из категорий типа "Нужна услуга".
export function ChatDetailsExecutorForAd(props: Props) {

    const {
        executor,
    } = props

    return (
        <div className="chat-executor-info mb-3 d-flex flex-row align-items-start justify-content-start">
            <div>
                <Link
                    to={makeExecutorUrl(executor.id)}
                    target="_blank"
                    rel="noreferrer"
                    className="d-block"
                >
                    <img
                        src={executor.cover}
                        alt=""
                        className="img rounded-2 me-3"
                    />
                </Link>
            </div>
            <div className="flex-1">
                <div className="fw-500">
                    {trans().cabinet.chats.executor_profile}:
                </div>
                <Link
                    to={makeExecutorUrl(executor.id)}
                    target="_blank"
                    rel="noreferrer"
                    className="link-blue"
                >
                    {executor.title}
                </Link>
                <LabeledValue label={trans().cabinet.chats.executor_category}>
                    {executor.category}
                </LabeledValue>
            </div>
        </div>
    )
}
